import React from 'react';
import './HealthTips.css';
import { FaTint, FaAppleAlt, FaRunning, FaBed, FaSpa, FaBan, FaUserMd, FaHandSparkles, FaUsers, FaBookOpen, FaArrowRight } from 'react-icons/fa';

const HealthTips = () => {
    const tips = [
        {
            icon: <FaTint />,
            text: "Stay hydrated by drinking at least 8 glasses of water a day.",
            title: "Hydration"
        },
        {
            icon: <FaAppleAlt />,
            text: "Eat a balanced diet rich in fruits and vegetables.",
            title: "Nutrition"
        },
        {
            icon: <FaRunning />,
            text: "Exercise regularly for at least 30 minutes a day.",
            title: "Exercise"
        },
        {
            icon: <FaBed />,
            text: "Get enough sleep, aiming for 7-9 hours per night.",
            title: "Sleep"
        },
        {
            icon: <FaSpa />,
            text: "Practice stress management techniques like meditation.",
            title: "Mental Peace"
        },
        {
            icon: <FaBan />,
            text: "Avoid smoking and limit alcohol consumption.",
            title: "Habits"
        },
        {
            icon: <FaUserMd />,
            text: "Schedule regular health check-ups with your doctor.",
            title: "Check-ups"
        },
        {
            icon: <FaHandSparkles />,
            text: "Maintain good hygiene to prevent infections.",
            title: "Hygiene"
        },
        {
            icon: <FaUsers />,
            text: "Stay socially connected with friends and family.",
            title: "Social"
        },
        {
            icon: <FaBookOpen />,
            text: "Learn something new to keep your mind active.",
            title: "Learning"
        }
    ];

    return (
        <div className="health-tips-page">
            <header className="health-tips-hero">
                <div className="container">
                    <div className="hero-content">
                        <h1>Daily Health Tips</h1>
                        <p>Small changes can make a big difference. Explore our expert-curated guide to living a healthier, happier life.</p>
                        <div className="hero-decoration"></div>
                    </div>
                </div>
            </header>

            <section className="tips-section">
                <div className="container">
                    <div className="tips-grid">
                        {tips.map((tip, index) => (
                            <article key={index} className="tip-card">
                                <div className="card-content">
                                    <div className="tip-icon-wrapper">
                                        {tip.icon}
                                    </div>
                                    <div className="text-content">
                                        <h3>{tip.title}</h3>
                                        <p>{tip.text}</p>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <span className="tip-number">Tip {index + 1 < 10 ? `0${index + 1}` : index + 1}</span>
                                    <div className="w-100"></div>
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default HealthTips;
